/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteClientInput = {
    id: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteClientMutationVariables = {
    input: DeleteClientInput;
};
export type deleteClientMutationResponse = {
    readonly deleteClient: {
        readonly deletedClientId: string | null;
    } | null;
};
export type deleteClientMutation = {
    readonly response: deleteClientMutationResponse;
    readonly variables: deleteClientMutationVariables;
};



/*
mutation deleteClientMutation(
  $input: DeleteClientInput!
) {
  deleteClient(input: $input) {
    deletedClientId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteClientInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteClientPayload",
    "kind": "LinkedField",
    "name": "deleteClient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedClientId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteClientMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteClientMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteClientMutation",
    "operationKind": "mutation",
    "text": "mutation deleteClientMutation(\n  $input: DeleteClientInput!\n) {\n  deleteClient(input: $input) {\n    deletedClientId\n  }\n}\n"
  }
};
})();
(node as any).hash = '4dceffefee02f585556b2e999d63bcf3';
export default node;
